const driveDirections = {
  Left: 'left',
  Right: 'right'
}

export default driveDirections



// WEBPACK FOOTER //
// ./src/driveDirection.js